import { render } from "./AddAudience.vue?vue&type=template&id=021aaaee&scoped=true"
import script from "./AddAudience.vue?vue&type=script&lang=js"
export * from "./AddAudience.vue?vue&type=script&lang=js"

import "./AddAudience.vue?vue&type=style&index=0&id=021aaaee&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021aaaee"]])

export default __exports__